import docPackagesSaga from './dutyOfCare';

const packagesSagasRoot = [docPackagesSaga()];

export default packagesSagasRoot;
